import { render, staticRenderFns } from "./LoginWeChat.vue?vue&type=template&id=47c25e3b&scoped=true"
import script from "./LoginWeChat.vue?vue&type=script&lang=js"
export * from "./LoginWeChat.vue?vue&type=script&lang=js"
import style0 from "./LoginWeChat.vue?vue&type=style&index=0&id=47c25e3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c25e3b",
  null
  
)

export default component.exports